import React from 'react'
import Card from '../../components/card'
import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../main/authProvider'
import TransactionService from '../../app/service/estoque/transactionService'
import GeneralServices from '../../app/service/generalServices'
import TransactionByNFTable from './transactionByNFTable'
import ProgressService from '../../app/service/progressService'
import NFService from '../../app/service/estoque/NFService'
import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import ConstantsUtil from '../../context/constantsUtil'
import { Button } from 'primereact/button'
import ConfiguracaoEmpresaService from '../../app/service/configuracaoEmpresaService'
import HandleErrorService from '../../app/service/handleErrorService'

class ValidacaoNFsEntrada extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        this.progressService = new ProgressService();
        this.transactionService = new TransactionService();
        this.NFService = new NFService();
        this.configuracaoEmpresaService = new ConfiguracaoEmpresaService();
    }

    state = {
        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        
        habilitaBusca: true,
    }

    componentDidMount(){
        this.checaConfigucarao()
        this.autoSearch()
    }

    checaConfigucarao = () => {
        if(window.location.pathname === ConstantsUtil.preValidacaoNFsEntrada){
        this.configuracaoEmpresaService.search()
        .then(response => {
            let configuracaoEmpresa = response.data
            if(!configuracaoEmpresa.possuiPreValidacaoNFsEntrada){
                window.location.href = ConstantsUtil.homePathname
            }
            // console.log("completaLogin: ", user)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        }
    }

    autoSearch = async () => {
        await this.generalServices.sleep(100)
        this.search()
    }

    handleDateFilterChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.setState({initialDate})
        // console.log("handleDateChange initial: ", this.state.initialDate)
        
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})
        // console.log("handleDateChange initialView: ", this.state.initialDateView)

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})

    }    

    getDataInicial = () => {
        
        let dataInicial = new Date()
        dataInicial.setDate(dataInicial.getDate() - 7)
        return dataInicial;

    }

    getDataFinal = () => {
        
        let dataInicial = new Date()
        // dataInicial.setDate(dataInicial.getDate() - 3)
        return dataInicial;

    }

    search = () => {
        this.setState({habilitaBusca: false})
    }

    getLabel(){

        let label = "Validação das NFs de Entrada"

        switch(window.location.pathname){
            
            case ConstantsUtil.preValidacaoNFsEntrada:
                return `Pré-${label}`
                
            case ConstantsUtil.validacaoNFsEntrada:
                return label

        }
    }

    render() {

        // const renderButtons = () => {
        //     if(this.state.habilitaBusca){
        //         return (
        //             <Button
        //                 label="Buscar"
        //                 icon="pi pi-search"
        //                 className='small-button'
        //                 onClick = {this.search}
        //             />
        //         )
        //     }
        //     return (
        //         <>
        //             <Button 
        //                 label="Voltar"
        //                 icon="pi pi-undo"
        //                 className="p-button-danger small-button"
        //                 onClick = {() => {
        //                     this.setState({filterNFTableState: {}})
        //                     this.setState({habilitaBusca: true})
        //                 }}
        //             />
        //         </>
        //     )            
        // }

        const renderTable = () => {
            if(!this.state.habilitaBusca){
                return (
                    <TransactionByNFTable
                        validateNFs
                        // dataInicial={this.state.initialDate}
                        // dataFinal={this.state.finalDate}
                    />
                )
            }
        }

        return (
                   
            <div className="bs-docs-section" >
                
                <Card title = {this.getLabel()}>
                    {/* <div className="row">
                        <DateIntervalCalendar
                            htmlFor="SelectDatePeriod"
                            // defaultValue={ConstantsUtil.calendarPersonalizadoFilterLabel}
                            handleFilterChange={this.handleDateFilterChange}
                            handleDateChange={this.handleDateChange}
                            missingFilterType={this.state.missingFilterType}
                            missingAnyDate={this.state.missingAnyDate}
                            disabled={!this.state.habilitaBusca}
                            preSetFilterType={ConstantsUtil.calendarPersonalizadoFilterLabel}
                            preSetDataInicial={this.getDataInicial()}
                            preSetDataFinal={this.getDataFinal()}
                            enableChangeFilterType
                        />
                    </div>

                    <div
                        style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}
                    >
                        {renderButtons()}
                    </div>                     */}

                    {renderTable()}

                </Card>
                <div className="d-flex "/>
            </div>
              
        )
    }


}

ValidacaoNFsEntrada.contextType = AuthContext

export default withRouter(ValidacaoNFsEntrada)